export default "__VITE_ASSET__tB6wn661__"